/**
 * Form layout modes. Leaf module with no dependencies so tests that mock
 * `../Form` (or any other heavy module) can import the real enum without
 * duplicating its string values — they are load-bearing for the
 * `[data-layout="..."]` CSS selectors in PreviewForm.css.
 */
export const FORM_LAYOUT = Object.freeze({
  // One item-group per page, Next / Back navigation. The participant flow.
  PAGED: "paged",
  // Every visible item-group stacked on one scrollable surface, no paging.
  // Designer-preview only — a review convenience, never a participant flow.
  ALL_GROUPS: "all-groups",
});
